import { RenouvellementTemplate } from '../templates/renouvellement.tpl';

export const RenouvellementDocument = {
    id: 'Bilan',
    template: RenouvellementTemplate,
    model: {
        title: 'Bilan',
        description: 'Quantité des produits pétroliers enlevées des dépôts par camion et par marketeUr',
        pageOrientation: 'landscape',
        columnsHeader:[],
        columnsSize:[],
        query: (params: any) => {
            return[]
            ;
        },
        params: (fluid:string) => [],
        sums:(fluid:string) => []
    }
};